import {Button} from 'platform/components';
import {Box, HStack} from 'platform/foundation';

import {isNotNil} from 'ramda';

import i18n from '@dms/i18n';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

import type {AiMessageComposerController} from '../useAiMessageComposer';
import {AiComposerPromptInput} from './AiComposerPromptInput';
import {AiComposerSurface} from './AiComposerSurface';

const INSTRUCTION_WIDTH = 64;

interface AiComposerSelectionActionsProps extends RequiredTestIdProps {
  controller: AiMessageComposerController;
}

export function AiComposerSelectionActions(props: AiComposerSelectionActionsProps) {
  const controller = props.controller;
  if (
    !controller.isEnabled ||
    controller.isEntryDisabled ||
    !controller.canRefineSelection ||
    controller.isPending ||
    isNotNil(controller.proposal)
  ) {
    return null;
  }

  const handleRefineSelection = () => {
    controller.onOpen();
    controller.onRefineSelection();
  };

  return (
    <AiComposerSurface $variant="toolbar">
      <HStack spacing={1} align="center">
        <div onMouseDown={(event) => event.stopPropagation()}>
          <Box width={INSTRUCTION_WIDTH}>
            <AiComposerPromptInput
              label={i18n.t('general.aiMessageComposer.labels.selectionInstructionPlaceholder')}
              placeholder={i18n.t(
                'general.aiMessageComposer.labels.selectionInstructionPlaceholder'
              )}
              value={controller.selectionInstruction}
              isDisabled={controller.isPending}
              isAutoFocused={false}
              onChange={controller.onSelectionInstructionChange}
              onSubmit={handleRefineSelection}
              data-testid={suffixTestId('selectionInstruction', props)}
            />
          </Box>
        </div>
        <Button
          size="small"
          variant="ghostLink"
          leftIcon="action/magic_wand"
          title={i18n.t('general.aiMessageComposer.actions.refineSelection')}
          wrap
          onClick={handleRefineSelection}
          data-testid={suffixTestId('refineSelection', props)}
        />
      </HStack>
    </AiComposerSurface>
  );
}
